var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 38710",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.447,
    height: 50.447,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141648",
    fill: "#dc1e1e",
    stroke: "#707070",
    d: "M0 0h31.676v31.676H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 6023",
    fill: "#dc1e1e",
    stroke: "#dc1e1e",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.223,
    cy: 25.223,
    r: 25.223,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.223,
    cy: 25.223,
    r: 24.723,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1495",
    transform: "translate(9.385 9.385)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141647",
    fill: "none",
    d: "M0 0h31.676v31.676H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38709",
    fill: "#dc1e1e",
    transform: "translate(.952 .499)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47810",
    d: "m14.684 3.975 11.1 20.053H3.655L14.684 3.975M.179 24.696a1.337 1.337 0 0 0 1.136 2.005h26.738a1.337 1.337 0 0 0 1.136-2.005L15.821.633a1.337 1.337 0 0 0-2.273 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47811",
    d: "M13.347 10.659v6.016a1.337 1.337 0 1 0 2.674 0v-6.016a1.337 1.337 0 0 0-2.674 0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6024",
    cx: 1.337,
    cy: 1.337,
    r: 1.337,
    transform: "translate(13.347 19.349)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.a20fc81fa277ac4eb2e1eb2a89acf6ba.svg";
export { ForwardRef as ReactComponent };